import { render, staticRenderFns } from "./DraftDetail.vue?vue&type=template&id=7df62ad6&scoped=true"
import script from "./DraftDetail.vue?vue&type=script&lang=js"
export * from "./DraftDetail.vue?vue&type=script&lang=js"
import style0 from "./DraftDetail.vue?vue&type=style&index=0&id=7df62ad6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df62ad6",
  null
  
)

export default component.exports